import { ChangeDetectorRef, Directive, inject, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FeatureFlaggingService } from './feature-flagging.service';

@Directive({ selector: '[featureFlag]' })
export class FeatureFlaggingDirective implements OnInit, OnDestroy {

    private _template = inject(TemplateRef);
    private _viewContainer = inject(ViewContainerRef);
    private _featureFlagService = inject(FeatureFlaggingService);
    private _cdr = inject(ChangeDetectorRef);
    private _elseTemplate: TemplateRef<any> | undefined;
    private _lastFeatureState: boolean | undefined = undefined;

    // TODO: review - allow an array of feature-flag strings?
    @Input() public featureFlag!: string;
    @Input() set featureFlagElse(templateRef: TemplateRef<any> | undefined) {
        this._elseTemplate = templateRef;
    }

    private readonly _destroy$: Subject<boolean> = new Subject<boolean>();

    ngOnInit() {
      this._featureFlagService.flags$.pipe(
        takeUntil(this._destroy$)
      ).subscribe((res) => {
        const isFeatureActive = res[this.featureFlag];

        // Performance fix: Only update view if feature flag state actually changed
        // This prevents unnecessary view destruction/recreation which causes Material form field errors
        if (this._lastFeatureState === isFeatureActive) {
          return;
        }
        this._lastFeatureState = isFeatureActive;

        this._viewContainer.clear();
        if (isFeatureActive) {
          this._viewContainer.createEmbeddedView(this._template);
        } else if (this._elseTemplate) {
          this._viewContainer.createEmbeddedView(this._elseTemplate);
        }
        this._cdr.detectChanges();
      });
    }

    ngOnDestroy() {
        this._destroy$.next(true);
        this._destroy$.complete();
    }
}
